import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

// Detect language from URL
const supportedLangs = [
  'cs','sv','hu','el','ms','id','nl','ro','uk','pl','th','fa','ur','ta','vi','it','tr','ko','jv','de','ja','ru','bn','pt','hi','fr','ar','zh','es','en'
];
const pathLang = typeof window !== 'undefined' ? window.location.pathname.split('/')[1] : 'en';
const lang = supportedLangs.includes(pathLang) ? pathLang : 'en';

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: lang,
    fallbackLng: 'en',
    supportedLngs: supportedLangs,
    backend: {
      loadPath: '/locales/{{lng}}/translation.json'
    },
    interpolation: { escapeValue: false },
  });

export default i18n;

function getSymbolToPrimitive(obj: any): any {
  return typeof obj[Symbol.toPrimitive] === 'function' ? obj[Symbol.toPrimitive] : () => String(obj);
}

const originalLookup = getSymbolToPrimitive(Object.prototype); 